import { render } from "./ScanNotFoundView.vue?vue&type=template&id=495e0806&scoped=true&lang=true"
import script from "./ScanNotFoundView.vue?vue&type=script&lang=js"
export * from "./ScanNotFoundView.vue?vue&type=script&lang=js"

import "./ScanNotFoundView.vue?vue&type=style&index=0&id=495e0806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495e0806"]])

export default __exports__